var e=["40em","52em","64em","80em","100em"];export{e as breakpoints};
//# sourceMappingURL=breakpoints.js.map
